module.exports = __webpack_public_path__ + "img/camper_1.2dc2010e.jpg";